module.exports = __webpack_public_path__ + "static/media/three-dot-menu.0590771a.svg";